var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4425 6.73369C30.3527 3.64396 26.2431 1.94611 21.8755 1.94611C17.5019 1.94611 13.3982 3.64396 10.3085 6.73369C7.21875 9.82342 5.51489 13.9331 5.51489 18.3007C5.51489 27.1379 13.8722 34.4933 18.3658 38.441C18.9897 38.9929 19.5237 39.4669 19.9556 39.8628C20.4956 40.3668 21.1855 40.6188 21.8755 40.6188C22.5654 40.6188 23.2554 40.3668 23.7893 39.8628C24.2213 39.4669 24.7612 38.9929 25.3852 38.441C29.8728 34.4933 38.2301 27.1379 38.2301 18.3007C38.2301 13.9331 36.5322 9.82342 33.4425 6.73369V6.73369Z",
    fill: "#0E64A9",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9496 15.0988L20.8683 9.00848C20.5315 8.8531 20.1317 8.99794 19.9747 9.33289L17.256 15.1532C17.1805 15.3144 17.1726 15.4992 17.2337 15.6664C17.2948 15.8335 17.4195 15.9699 17.581 16.0453L19.5907 16.981L18.8941 18.4727C18.8186 18.6339 18.8107 18.8187 18.8718 18.9859C18.9328 19.153 19.0575 19.2894 19.219 19.3648L20.4456 19.9359L18.8468 23.3595H16.8595V21.9036C16.8595 21.5325 16.5588 21.2323 16.1872 21.2323C15.8156 21.2323 15.5149 21.5325 15.5149 21.9036V26.1565C15.5149 26.5275 15.8156 26.8278 16.1872 26.8278C16.5588 26.8278 16.8595 26.5275 16.8595 26.1565V24.7019H19.2748C19.5361 24.7019 19.7738 24.5505 19.8841 24.3145L21.6643 20.5031L22.887 21.0724C22.979 21.115 23.0755 21.1354 23.1707 21.1354C23.4241 21.1354 23.6664 20.9917 23.7807 20.7479L24.4773 19.2562L28.4079 21.0861C28.4997 21.1288 28.5963 21.1491 28.6914 21.1491C28.9449 21.1491 29.1871 21.0056 29.3014 20.7617L29.4056 20.5385L31.0511 21.3045C31.1429 21.347 31.2395 21.3674 31.3346 21.3674C31.5881 21.3674 31.8303 21.2238 31.9446 20.98L33.4979 17.6539C33.6548 17.3176 33.5091 16.9185 33.173 16.7618L32.9268 16.6472L33.8702 16.3462C34.1335 16.2623 34.3186 16.0256 34.3363 15.7497C34.3541 15.4737 34.2004 15.2154 33.9496 15.0988ZM31.8232 15.5903L30.4858 16.0172L20.5065 11.3708L20.9089 10.5088L31.8232 15.5903ZM29.9743 19.3222L30.8081 17.5357C30.8479 17.4544 30.9161 17.2353 31.0393 17.2494L31.9951 17.6946L31.0103 19.804L29.9743 19.3222Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3542",
    x: 0.0148926,
    y: 0.446106,
    width: 43.7152,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3542",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a47db85487bfaf60f1608b939ad9743d.svg";
export { ForwardRef as ReactComponent };